import classNames from 'classnames';
import React from 'react';
import Button, { ButtonWithLoadingState } from './Button';
import * as styles from './InPlaceEditControls.module.scss';

interface InPlaceEditControlsProps {
  saving: boolean;
  savingDisabled: boolean;
  onSaveClick(): void;
  onCancelClick(): void;
}

const InPlaceEditControls = ({
  saving,
  savingDisabled,
  onSaveClick,
  onCancelClick,
}: InPlaceEditControlsProps) => (
  <div className={classNames(styles.inPlaceEditControls)}>
    <ButtonWithLoadingState
      variant="primary"
      onClick={onSaveClick}
      disabled={savingDisabled}
      loading={saving}
    >
      Save
    </ButtonWithLoadingState>
    <Button variant="secondary" onClick={onCancelClick} disabled={saving}>
      Cancel
    </Button>
  </div>
);

export default InPlaceEditControls;
